import React, { useState, useEffect } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import PartnerService from "../../services/partners.service";

const Award = () => {
  const [awardList, setAwardList] = useState([]);

  useEffect(() => {
    PartnerService.awardList()
      .then((res) => setAwardList(res.data))
      .catch((err) => console.log(err));
  }, []);
  return (
    <>
      <Header topbarEnable="enable" />
      <Breadcrumb pageTitle={"Award & Recognition"} />
      <section className="container py-5">
        <p className="col-10 m-auto my-5 text-center fs-5">
          Ocfit has received multiple awards for its commitment to excellence in
          education and community service. These accolades reflect our
          dedication to empowering individuals and enhancing their quality of
          life. We take pride in our achievements, which motivate us to continue
          making a positive impact on society.
        </p>
        <div className="row row-cols-2 row-cols-md-3 g-md-5 g-3 mb-5">
          {awardList?.map((item, idx) => (
            <>
              <div key={idx} className="col">
                <div
                  className="awards_card shadow "
                >
                  <img
                    src={item?.logoUrl}
                    width={102}
                    height={102}
                    style={{ objectFit: "cover",height:"100%",width:"100%" }}
                    className="img-fluid  rounded"
                  />
                </div>
              </div>
            </>
          ))}
        </div>
      </section>
      <FooterTwo />
    </>
  );
};

export default Award;
